import {withActions} from 'carmi-host-extensions'
import _ from 'lodash'
export const name = 'RemoteRefsCompsAspect'

export const defaultModel = {
    fetchedRemoteRefs: {}
}

const fixStructureAndData = (page, pageId, flattenStructure, desktopOrMobileComponentsPath) => {
    const structure = flattenStructure(page.structure[desktopOrMobileComponentsPath][0])
    const {styleId, propertyQuery, connectionQuery, designQuery, behaviorQuery} = page.structure
    const mapNameToQuery = {
        theme_data: styleId,
        component_properties: propertyQuery,
        connections_data: connectionQuery,
        design_data: designQuery,
        behaviors_data: behaviorQuery
    }
    const data = _.mapValues(page.data, (dataMap, mapName) => {
        const filteredData = _(dataMap)
            .omitBy((val, key) => key === _.chain(mapNameToQuery).get(mapName).replace('#', '').value())
            .mapValues(dataItem => _.defaults({metaData: {...dataItem.metaData, pageId}}, dataItem)).value()
        return filteredData
    })

    return {...page, structure, data}
}

export const functionLibrary = {
    fetchRemoteRef: withActions((boltInstance, params) => {
        const {
            getFetchedRootId,
            primaryPageId,
            desktopOrMobileComponentsPath,
            flattenStructure,
            addPageStructureAndData,
            fetch,
            setTemplateRefs,
            setFetchedRemoteRefs
        } = params

        if (getFetchedRootId()) { // Case we already fetched for the remote we only need to setTemplateRef
            _.forEach(setTemplateRefs, setTemplateRef => setTemplateRef(getFetchedRootId()))
        } else {
            fetch(page => {
                if (_.has(page, ['structure', desktopOrMobileComponentsPath])) {
                    const rootId = _.get(page.structure[desktopOrMobileComponentsPath][0], 'id')
                    const structureAndDataToAdd = fixStructureAndData(page, primaryPageId, flattenStructure, desktopOrMobileComponentsPath)

                    boltInstance.$runInBatch(() => {
                        addPageStructureAndData(structureAndDataToAdd, rootId, boltInstance)
                        _.forEach(setTemplateRefs, setTemplateRef => setTemplateRef(rootId))
                        setFetchedRemoteRefs(rootId)
                    })
                }
            })
        }
    })
}
